import { createLazyOrchestrator } from 'owa-bundling';
import { getSuggestions, SearchScenarioId, searchSessionStarted } from 'owa-search';
import { setMaxEntries } from '../mutators/maxEntriesMutator';
import isFileSuggestionsSearchAction from '../utils/isFileSuggestionsSearchAction';
import { MAX_ENTRIES_TYPEDOWN } from '../utils/searchConstants';

/**
 * This is the file search specific searchSessionStarted orchestrator. It's responsible
 * for handling initialization.
 */
export const searchSessionStartedOrchestrator = createLazyOrchestrator(
    searchSessionStarted,
    'CLONE_SEARCH_SESSION_STARTED2',
    async actionMessage => {
        if (!isFileSuggestionsSearchAction(actionMessage.scenarioId)) {
            return;
        }
        // Set the maxEntries to the default
        setMaxEntries(MAX_ENTRIES_TYPEDOWN);

        // Get zero input text suggestions
        getSuggestions(SearchScenarioId.FileSuggestions);
    }
);
